import { checkStatus } from '../../../../utilities/fetch';
import { createQueryString } from '../../../../utilities/utilities';
import { favoritesPath } from '../../../../utilities/api_relative_paths';
import { ToggleFavoriteResponse, ToggleFavoriteQueryParams } from '../types';

export const toggleFavorite = (
  id: number | null,
  isFavorite: boolean): Promise<ToggleFavoriteResponse> => {
  if (!id) return Promise.reject('Missing param: id');

  const queryParams: ToggleFavoriteQueryParams = isFavorite ?
    { object_type: 'Job', object_id: id } :
    {
      favorite: {
        object_type: 'Job',
        object_id: id,
        name: 'favorite',
        folder_name: 'Jobs'
      }
    };
  const url = favoritesPath + createQueryString(queryParams);
  const method = isFavorite ? 'DELETE' : 'POST';

  return fetch(url, {method})
    .then(checkStatus)
    .then((response) => response.json());
};
